




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { FindRepositoriesDetail } from '@/@types/theoryGit/repositoryInfo';

@Component({
  components: {
    CommonButton,
  },
})
export default class RepositoryCard extends Vue {
  @Prop({ required: true, default: () => {} })
  private repository!: FindRepositoriesDetail;

  private async moveToRepositoryPage() {
    const repositoryInfoId = this.repository.repositoryInfoId;
    this.$router.push({
      name: 'repository',
      params: { id: String(repositoryInfoId) },
    });
  }
}
